module.exports = __webpack_public_path__ + "static/artworking-1-adc12969afba584572cd86422622a6cc.jpg";